import cn from 'classnames';

import { Badge, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';

import Icon from './partials';
import { Emojis, MediaRequestCta } from '@src/components';

import useFooterActionsConfig, { TFooterActionConfig } from '../../useFooterActionsConfig';

import './Icons.scss';

const Icons = ({
  isExpanded,
  isDocumentPIP = false,
  onHideSheet,
}: {
  isExpanded?: boolean;
  isDocumentPIP?: boolean;
  onHideSheet: () => {};
}) => {
  const { mobileTop, mobileExpanded, handleEmojiClick } = useFooterActionsConfig();

  const renderAction = (action: TFooterActionConfig) => {
    // Handle custom renders
    if (action.mobile?.customRender === 'emojis') {
      return (
        <Grid size={1} key={action.id}>
          <Icon
            isExpanded={isExpanded}
            className={action.mobile.containerClass || ''}
            title={action.label || ''}
            onClick={() => {}}
          >
            <Emojis
              isDocumentPIP={isDocumentPIP}
              onSelect={(reactionId) => {
                handleEmojiClick(reactionId);
                onHideSheet();
              }}
            />
          </Icon>
        </Grid>
      );
    }

    // Render icon with badge if configured
    const renderIcon = () => {
      if (action.mobile?.badge?.show) {
        return (
          <Badge badgeContent={action.mobile.badge.content} className={action.mobile.badge.className || ''}>
            {action.icon}
          </Badge>
        );
      }
      return action.icon;
    };

    // Render CTA if configured
    const renderCTA = () => {
      const cta = action.mobile?.cta;
      if (!cta) return null;

      return (
        <MediaRequestCta
          hostName={cta.hostName}
          message={cta.message}
          buttonLabel={cta.buttonLabel}
          anchorRef={cta.anchorRef}
          open={true}
          onConfirm={cta.onConfirm}
          roleLabel={cta.roleLabel}
          onClose={cta.onClose}
          request={cta.request}
        />
      );
    };

    const handleClick = (e?: any) => {
      if (e?.preventDefault) e.preventDefault();
      action.onClick?.();
      // Only close sheet if it's not a custom render (e.g. emoji picker needs to stay open)
      if (!action.mobile?.customRender) {
        onHideSheet();
      }
      if (e?.currentTarget?.blur) e.currentTarget.blur();
    };

    const className = cn(action.mobile?.containerClass || '', {
      closed: action.mobile?.isClosed || false,
      active: action.isActive,
      disabled: action.isDisabled,
    });

    return (
      <Grid size={1} key={action.id} ref={action.ref}>
        <Icon isExpanded={isExpanded} className={className} title={action.label || ''} onClick={handleClick}>
          {action.hasNotification && <div className="notification-indicator" />}
          {renderIcon()}
        </Icon>
        {renderCTA()}
      </Grid>
    );
  };

  return (
    <Stack width={1} spacing={2} className="expand-icons-container">
      <Grid container columns={5} spacing={2} justifyContent="center">
        {mobileTop.map(renderAction)}
      </Grid>
      {isExpanded && (
        <Grid container columns={5} spacing={2} justifyContent="center">
          {mobileExpanded.map(renderAction)}
        </Grid>
      )}
    </Stack>
  );
};

export default Icons;
